<h2 mat-dialog-title>Formas de frete disponíveis</h2>

<mat-dialog-content>
  @if (data.servicos.length === 0) {
  <p class="empty-text">Nenhum serviço encontrado para este contrato.</p>
  } @else {
  <div class="selecionar-todos">
    <mat-checkbox [checked]="isAllSelected()" [indeterminate]="isSomeSelected()" (change)="toggleAll()">
      Selecionar todos disponíveis
    </mat-checkbox>
  </div>

  <div class="lista-servicos">
    @for (servico of data.servicos; track servico.codigo) {
    <div class="servico-item" [class.ja-adicionado]="isJaAdicionado(servico)">
      <mat-checkbox [checked]="selection.isSelected(servico) || isJaAdicionado(servico)"
        [disabled]="isJaAdicionado(servico)" (change)="selection.toggle(servico)">
      </mat-checkbox>
      <div class="servico-body">
        <div class="servico-linha-principal">
          <span class="servico-codigo">{{ servico.codigo }}</span>
          <span class="servico-descricao">{{ servico.descricao }}</span>
          @if (isJaAdicionado(servico)) {
          <span class="status-badge badge-verde">Já adicionado</span>
          }
        </div>
        @if (servico.descSegmento) {
        <span class="servico-segmento">{{ servico.descSegmento }}</span>
        }
      </div>
    </div>
    }
  </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button class="btn-secondary" (click)="cancelar()">Cancelar</button>
  <button mat-flat-button class="btn-primary" (click)="adicionar()" [disabled]="selection.selected.length === 0">
    Adicionar ({{ selection.selected.length }})
  </button>
</mat-dialog-actions>